import { put, takeLatest, select } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { notification } from 'antd';
import { setNotification } from 'utils';
import * as BoxActions from '../actions/boxActions';
import * as BoxApi from '../api/boxApi';
import * as BoxTypes from '../types/boxTypes';

const getBox = state => state.box;
const getLayout = state => state.layout;

// L O A D   B O X E S
function* loadBoxesSaga() {
    try {
        const box = yield select(getBox);
        const { offset, limit } = box;

        const params = { offset, limit };

        if (box.sort !== null) {
            const sortInt = box.sort.type === 'asc' ? 1 : -1;

            if (box.sort.key === 'name') {
                params.sort_by = JSON.stringify({ unique_name: sortInt });
            } else if (box.sort.key === 'created_at') {
                params.sort_by = JSON.stringify({ created_at: sortInt });
            }
        }

        if (box.filters.package_name !== '') {
            params.filter = JSON.stringify({
                package_name: {
                    operator: 'typing',
                    value: box.filters.package_name,
                },
            });
        }

        const result = yield BoxApi.getBoxesApi(params);
        yield put(BoxActions.loadBoxesRes(result.data));
    } catch (e) {
        yield put(BoxActions.loadBoxesErr());
        console.log(e);
    }
}

export function* loadBoxesWatcher() {
    yield takeLatest(BoxTypes.LOAD_BOXES, loadBoxesSaga);
}
// L O A D   B O X E S


// A D D   B O X
function* addBoxSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield BoxApi.addBoxApi(action.data);

        if (result.status === 202) {
            yield put(BoxActions.addBoxRes());

            yield put(push('/logistics/boxes'));

            setNotification('success', locale, 'global.success', 'boxes.notification.add.success');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(BoxActions.addBoxErr());
        }
    } catch (e) {
        yield put(BoxActions.addBoxErr());
        setNotification('error', locale, 'global.error', 'boxes.notification.add.error');
        console.log(e);
    }
}

export function* addBoxWatcher() {
    yield takeLatest(BoxTypes.ADD_BOX, addBoxSaga);
}
// A D D   B O X

// E D I T   B O X
function* editBoxSaga(action) {
    const layout = yield select(getLayout);
    const { locale } = layout;

    try {
        const result = yield BoxApi.editBoxApi(action.data);

        if (result.status === 202) {
            yield put(BoxActions.editBoxRes());

            yield put(push('/logistics/boxes'));

            setNotification('success', locale, 'global.success', 'boxes.notification.edit.success');
        } else {
            const error = yield result.json();
            setNotification('error', locale, 'global.error', error.message, { noTranslateMsg: true });
            yield put(BoxActions.editBoxErr());
        }
    } catch (e) {
        yield put(BoxActions.editBoxErr());
        setNotification('error', locale, 'global.error', 'boxes.notification.edit.error');
        console.log(e);
    }
}

export function* editBoxWatcher() {
    yield takeLatest(BoxTypes.EDIT_BOX, editBoxSaga);
}
// E D I T   B O X

// L O A D   E D I T A B L E   B O X
function* loadEditableBoxSaga(action) {
    try {
        const params = { filter: JSON.stringify({ _id: action.id }) };

        const resultBox = yield BoxApi.getBoxesApi(params);

        if (resultBox.data.hits.length === 0) {
            notification.error({
                message: 'Error',
                description: 'Box don\'t exist',
            });

            yield put(push('/404'));
            yield put(BoxActions.loadBoxesErr());
        } else {
            const [box] = resultBox.data.hits;
            yield put(BoxActions.loadEditableBoxRes(box));
        }
    } catch (e) {
        yield put(BoxActions.loadBoxesErr());
        console.log(e);
    }
}

export function* loadEditableBoxWatcher() {
    yield takeLatest(BoxTypes.LOAD_EDITABLE_BOX, loadEditableBoxSaga);
}
// L O A D   E D I T A B L E   B O X
